/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Listingnotfounderror3Inputs */

const en_listingnotfounderror3 = /** @type {(inputs: Listingnotfounderror3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listing not found.`)
};

const de_listingnotfounderror3 = /** @type {(inputs: Listingnotfounderror3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ort nicht gefunden.`)
};

/**
* | output |
* | --- |
* | "Listing not found." |
*
* @param {Listingnotfounderror3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const listingnotfounderror3 = /** @type {((inputs?: Listingnotfounderror3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Listingnotfounderror3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_listingnotfounderror3(inputs)
	return de_listingnotfounderror3(inputs)
});
export { listingnotfounderror3 as "listingNotFoundError" }